// extracted by mini-css-extract-plugin
export default {"receipt_card":"Receipt_receipt_card__+fbCH","receipt_img":"Receipt_receipt_img__B6SoR"};